import React, { Component } from 'react';
import { Table, Button, Modal, Select, Input, Icon, Row, Col, Alert } from 'antd';
import CiclicosConfigRequest from '../../services/CiclicosConfig';
import { openNotification } from '../../util/notificaciones';

const { Option } = Select;

export default class AgregarArticulosModal extends Component {
    state = {
        modalFrecuencia: 1,
        modalSearch: '',
        articulosDisponibles: [],
        loadingModal: false,
        selectedRowKeysModal: [],
        selectedArticulosMap: {},
        pageModal: 1,
        pageSizeModal: 5,
        totalCountModal: 0,
        savingModal: false,
        confirmVisible: false,
        frecuencias: [],
        articulosConError: {}
    };

    componentDidMount() {
        this.cargarFrecuencias();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.abrir();
        }
    }

    componentWillUnmount() {
        if (this.modalSearchTimeout) clearTimeout(this.modalSearchTimeout);
    }

    abrir = () => {
        const { isAdmin } = this.props;
        this.setState({
            modalFrecuencia: isAdmin ? 1 : 2,
            modalSearch: '',
            selectedRowKeysModal: [],
            selectedArticulosMap: {},
            pageModal: 1,
            confirmVisible: false,
            articulosConError: {}
        }, () => {
            this.cargarArticulosDisponibles();
        });
    };

    cargarFrecuencias = () => {
        CiclicosConfigRequest.ListarFrecuencias()
            .then(res => {
                this.setState({ frecuencias: res.data || [] });
            })
            .catch(() => {
            });
    };

    cargarArticulosDisponibles = () => {
        const { isAdmin, selectedPdv } = this.props;
        const { modalFrecuencia, modalSearch, pageModal, pageSizeModal } = this.state;
        this.setState({ loadingModal: true });

        const requestId = (this.modalRequestSeq = (this.modalRequestSeq || 0) + 1);

        const params = {
            frecuencia_id: isAdmin ? 1 : modalFrecuencia,
            pdv_id: isAdmin ? null : selectedPdv,
            search: modalSearch,
            page: pageModal,
            page_size: pageSizeModal
        };

        CiclicosConfigRequest.ListarArticulosDisponibles(params)
            .then(res => {
                if (requestId !== this.modalRequestSeq) return;
                const responseData = res.data?.data || {};
                this.setState({
                    articulosDisponibles: responseData.articulos || [],
                    totalCountModal: responseData.count || 0,
                    loadingModal: false
                });
            })
            .catch(err => {
                if (requestId !== this.modalRequestSeq) return;
                this.setState({ loadingModal: false });
                const msg = err?.response?.data?.message || 'Error al cargar artículos disponibles.';
                openNotification(msg, 'Error');
            });
    };

    handleClose = () => {
        if (this.modalSearchTimeout) clearTimeout(this.modalSearchTimeout);
        this.setState({
            selectedRowKeysModal: [],
            selectedArticulosMap: {},
            articulosDisponibles: [],
            confirmVisible: false,
            articulosConError: {}
        });
        this.props.onClose();
    };

    handleModalFrecuenciaChange = (value) => {
        this.setState({ modalFrecuencia: value });
    };

    handleModalSearchChange = (e) => {
        const value = e.target ? e.target.value : (e || '');
        this.setState({ modalSearch: value });

        if (this.modalSearchTimeout) {
            clearTimeout(this.modalSearchTimeout);
        }

        this.modalSearchTimeout = setTimeout(() => {
            this.setState({ pageModal: 1 }, () => {
                this.cargarArticulosDisponibles();
            });
        }, 400);
    };


    handleSave = () => {
        const { isAdmin, selectedPdv } = this.props;
        const { selectedRowKeysModal } = this.state;

        if (selectedRowKeysModal.length === 0) {
            openNotification('Debe seleccionar al menos un artículo a agregar.', 'Aviso');
            return;
        }

        if (!isAdmin && !selectedPdv) {
            openNotification('Debe tener un Punto de Venta seleccionado para asignar artículos.', 'Aviso');
            return;
        }

        this.setState({ confirmVisible: true });
    };

    handleRegresarConfirmacion = () => {
        this.setState({ confirmVisible: false });
    };

    handleQuitarArticuloResumen = (id) => {
        this.setState(prevState => {
            const selectedRowKeysModal = prevState.selectedRowKeysModal.filter(key => String(key) !== String(id));
            const selectedArticulosMap = { ...prevState.selectedArticulosMap };
            delete selectedArticulosMap[id];
            const articulosConError = { ...prevState.articulosConError };
            delete articulosConError[id];

            return { selectedRowKeysModal, selectedArticulosMap, articulosConError };
        });
    };

    handleConfirmarGuardado = () => {
        const { isAdmin, selectedPdv, onSaved } = this.props;
        const { selectedRowKeysModal, modalFrecuencia } = this.state;

        this.setState({ savingModal: true, articulosConError: {} });

        const payload = {
            articulos: selectedRowKeysModal,
            frecuencia_id: isAdmin ? 1 : modalFrecuencia,
            pdv_id: isAdmin ? null : selectedPdv
        };

        CiclicosConfigRequest.GuardarConfiguraciones(payload)
            .then(res => {
                openNotification('Configuración registrada exitosamente.', 'Éxito');
                this.setState({ savingModal: false, confirmVisible: false });
                this.handleClose();
                onSaved();
            })
            .catch(err => {
                const erroresArticulos = err?.response?.data?.errors?.articulos;

                if (Array.isArray(erroresArticulos) && erroresArticulos.length > 0) {
                    const articulosConError = {};
                    erroresArticulos.forEach(e => { articulosConError[e.articulo_id] = e.mensaje; });
                    this.setState({ savingModal: false, articulosConError });
                    openNotification(`No se pudo guardar: ${erroresArticulos.length} artículo(s) tienen conflictos.`, 'Error');
                } else {
                    this.setState({ savingModal: false });
                    const msg = err?.response?.data?.message || 'Error al guardar la configuración.';
                    openNotification(msg, 'Error');
                }
            });
    };

    render() {
        const { visible, isAdmin, selectedPdv, selectedPdvNombre } = this.props;
        const {
            modalFrecuencia,
            modalSearch,
            articulosDisponibles,
            loadingModal,
            selectedRowKeysModal,
            selectedArticulosMap,
            pageModal,
            pageSizeModal,
            totalCountModal,
            savingModal,
            confirmVisible,
            frecuencias,
            articulosConError
        } = this.state;

        const rowSelectionModal = {
            selectedRowKeys: selectedRowKeysModal,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState(prevState => {
                    const nuevoMapa = { ...prevState.selectedArticulosMap };
                    selectedRows.forEach(articulo => { nuevoMapa[articulo.id] = articulo; });

                    const clavesSeleccionadas = new Set(selectedRowKeys.map(String));
                    Object.keys(nuevoMapa).forEach(id => {
                        if (!clavesSeleccionadas.has(String(id))) {
                            delete nuevoMapa[id];
                        }
                    });

                    return { selectedRowKeysModal: selectedRowKeys, selectedArticulosMap: nuevoMapa };
                });
            }
        };

        const frecuenciaNacional = frecuencias.find(f => !f.requiere_pdv);
        const frecuenciasLocales = frecuencias.filter(f => f.requiere_pdv);
        const frecuenciaSeleccionadaId = isAdmin ? (frecuenciaNacional?.id ?? 1) : modalFrecuencia;
        let frecuenciaTexto = frecuencias.find(f => f.id === frecuenciaSeleccionadaId)?.nombre;
        if (!frecuenciaTexto) {
            if (isAdmin) {
                frecuenciaTexto = 'Diario';
            } else if (modalFrecuencia === 3) {
                frecuenciaTexto = 'Semanal';
            } else {
                frecuenciaTexto = 'Diario Adicional';
            }
        }
        const pdvTexto = isAdmin ? 'Todos los PDV' : (selectedPdvNombre || `PDV ${selectedPdv}`);
        const articulosSeleccionados = selectedRowKeysModal.map(id => selectedArticulosMap[id]).filter(Boolean);

        const columnsModal = [
            {
                title: 'Código',
                dataIndex: 'codigo',
                key: 'codigo',
                width: 140
            },
            {
                title: 'Nombre',
                dataIndex: 'nombre',
                key: 'nombre'
            },
            {
                title: 'UDMA',
                dataIndex: 'udma',
                key: 'udma',
                width: 120,
                align: 'center'
            },
            {
                title: 'UDMV',
                dataIndex: 'udmv',
                key: 'udmv',
                width: 120,
                align: 'center'
            }
        ];

        return (
            <Modal
                visible={visible}
                maskClosable={false}
                title={
                    <span style={{ fontSize: 18, fontWeight: 700 }}>
                        Agregar artículos
                    </span>
                }
                width={900}
                onCancel={this.handleClose}
                footer={[
                    <Button key="back" style={{ borderRadius: 4 }} onClick={this.handleClose}>
                        Regresar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={savingModal}
                        style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', borderRadius: 4 }}
                        onClick={this.handleSave}
                    >
                        Guardar
                    </Button>
                ]}
                destroyOnClose
            >
                <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                    <Col span={isAdmin ? 12 : 9}>
                        <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>Búsqueda:</div>
                        <Input
                            placeholder="Buscar por Código / Nombre..."
                            prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={modalSearch}
                            onChange={this.handleModalSearchChange}
                            allowClear
                        />
                    </Col>
                    <Col span={isAdmin ? 10 : 7}>
                        <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>Frecuencia:</div>
                        {isAdmin ? (
                            <Select disabled style={{ width: '100%' }} value={frecuenciaSeleccionadaId}>
                                <Option value={frecuenciaSeleccionadaId}>
                                    {frecuenciaNacional?.nombre || 'Diario (Nacional)'}
                                </Option>
                            </Select>
                        ) : (
                            <Select
                                style={{ width: '100%' }}
                                value={modalFrecuencia}
                                onChange={this.handleModalFrecuenciaChange}
                            >
                                {(frecuenciasLocales.length ? frecuenciasLocales : [{ id: 2, nombre: 'Diario Adicional' }, { id: 3, nombre: 'Semanal' }])
                                    .map(f => <Option key={f.id} value={f.id}>{f.nombre}</Option>)}
                            </Select>
                        )}
                    </Col>
                    {!isAdmin && (
                        <Col span={7}>
                            <div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>Punto de venta:</div>
                            <Input disabled value={pdvTexto} />
                        </Col>
                    )}
                </Row>

                <Table
                    rowSelection={rowSelectionModal}
                    columns={columnsModal}
                    dataSource={articulosDisponibles}
                    rowKey="id"
                    loading={loadingModal}
                    pagination={{
                        current: pageModal,
                        pageSize: pageSizeModal,
                        total: totalCountModal,
                        onChange: (page, pageSize) => {
                            this.setState({ pageModal: page, pageSizeModal: pageSize }, () => {
                                this.cargarArticulosDisponibles();
                            });
                        },
                        showSizeChanger: false
                    }}
                    locale={{ emptyText: 'No hay artículos disponibles para esta frecuencia.' }}
                />

                <Modal
                    visible={confirmVisible}
                    title={
                        <span style={{ fontSize: 18, fontWeight: 700 }}>
                            Resumen de configuración
                        </span>
                    }
                    width={700}
                    onCancel={this.handleRegresarConfirmacion}
                    footer={[
                        <Button key="back" style={{ borderRadius: 4 }} onClick={this.handleRegresarConfirmacion}>
                            Regresar
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            loading={savingModal}
                            disabled={articulosSeleccionados.length === 0}
                            style={{ backgroundColor: '#1890ff', borderColor: '#1890ff', borderRadius: 4 }}
                            onClick={this.handleConfirmarGuardado}
                        >
                            Aceptar
                        </Button>
                    ]}
                >
                    <p>
                        Se {selectedRowKeysModal.length === 1 ? 'agregará' : 'agregarán'} <b>{selectedRowKeysModal.length}</b> artículo(s)
                        con frecuencia <b>{frecuenciaTexto}</b> para <b>{pdvTexto}</b>.
                    </p>
                    {Object.keys(articulosConError).length > 0 &&
                        <Alert
                            type="error"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message={`${Object.keys(articulosConError).length} artículo(s) no se pueden registrar, revisa el detalle abajo.`}
                        />
                    }
                    <Table
                        columns={[
                            { title: 'Código', dataIndex: 'codigo', key: 'codigo', width: 140 },
                            { title: 'Nombre', dataIndex: 'nombre', key: 'nombre' },
                            ...(Object.keys(articulosConError).length > 0 ? [{
                                title: 'Estado',
                                key: 'estado',
                                width: 260,
                                render: (_, record) => articulosConError[record.id]
                                    ? <span style={{ color: '#f5222d' }}><Icon type="close-circle" /> {articulosConError[record.id]}</span>
                                    : <span style={{ color: '#52c41a' }}><Icon type="check-circle" /> Listo</span>
                            }] : []),
                            {
                                title: '',
                                key: 'quitar',
                                width: 40,
                                align: 'center',
                                render: (_, record) => (
                                    <Icon
                                        type="close"
                                        style={{ cursor: 'pointer', color: '#8c8c8c' }}
                                        title="Quitar de la lista"
                                        onClick={() => this.handleQuitarArticuloResumen(record.id)}
                                    />
                                )
                            }
                        ]}
                        dataSource={articulosSeleccionados}
                        rowKey="id"
                        pagination={false}
                        size="small"
                        scroll={{ y: 300 }}
                    />
                </Modal>
            </Modal>
        );
    }
}
